import * as actions from "./actionsTypes";

const initialData = {
  loaderOrigins: false,
  origins: null,
  originsFail: null,
  saveLoaderOrigins: false,
  originsFormError: null,
};

export default function OriginsReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_ORIGINS:
      return { ...state, loaderOrigins: action.payload };

    case actions.GET_ORIGINS:
      return { ...state, origins: action.payload };

    case actions.ORIGINS_FAIL:
      return { ...state, originsFail: action.payload };

    case actions.SAVE_LOADER_ORIGINS:
      return { ...state, saveLoaderOrigins: action.payload };

    case actions.FORM_ORIGINS_FAIL:
      return { ...state, originsFormError: action.payload };

    default:
      return state;
  }
}
